import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './styles/index.scss';
import { initI18n } from './i18n';
import App from './App';

async function bootstrap() {
  await initI18n();

  const container = document.getElementById('root');
  const app = (
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );

  if (container.firstElementChild) {
    ReactDOM.hydrateRoot(container, app);
  } else {
    ReactDOM.createRoot(container).render(app);
  }
}

bootstrap();
